import React from 'react';
import styled from 'styled-components';
import { themeColor } from '../../../styles/basics/colors';
import { BOLINDA_ICONS, isBolindaIcon, MATERIAL_ICONS } from '../Button/Icon';

const materialIconStyle = `
    font-family: "Material Icons";
    font-size: inherit;
    display: inline-block;
    width: 1em;
    height: 1em;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
   `;

const bolindaIconStyle = `
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'borrowbox-connect' !important;
    speak: none;
    font-variant: normal;

    /* Enable Ligatures ================ */
    letter-spacing: 0;
    -webkit-font-variant-ligatures: discretionary-ligatures;
    font-variant-ligatures: discretionary-ligatures;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
   `;

function isMaterialIcon(icon: string) {
    return MATERIAL_ICONS.includes(icon);
}

const ICONS = MATERIAL_ICONS.concat(BOLINDA_ICONS);

const StIcon = styled.i.attrs({ className: 'Icon' })<Omit<IconProps, 'icon'>>`
    font-weight: normal;
    font-style: normal;
    line-height: 1;
    text-transform: none;
    -webkit-font-feature-settings: 'liga';
    -moz-font-feature-settings: 'liga=1';
    -moz-font-feature-settings: 'liga';
    -ms-font-feature-settings: 'liga' 1;
    font-feature-settings: 'liga';
    ${props => (props._materialIcon ? materialIconStyle : null)};
    ${props => (props._bolindaIcon ? bolindaIconStyle : null)};
    color: ${props => (props.color ? themeColor(props.color) : 'inherit')};
    cursor: ${props => (props.clickable ? 'pointer' : 'inherit')};
`;
interface IconProps {
    readonly className?: any;
    readonly color?: string;
    readonly icon: (typeof ICONS)[number];
    readonly dataDisplayname?: string | undefined;
    readonly alt?: string;
    readonly title?: string;
    readonly onClick?: () => void;
    readonly _bolindaIcon?: boolean;
    readonly _materialIcon?: boolean;
    readonly _clickable?: boolean;
    readonly clickable?: boolean;
    readonly size?: any;
}
export const ProductGroupIcon = (props: IconProps) => {
    return (
        <StIcon
            data-displayname={props.dataDisplayname}
            alt={props.alt}
            title={props.title}
            color={props.color}
            onClick={props.onClick}
            className={props.className}
            _clickable={!!props.onClick}
            _bolindaIcon={isBolindaIcon(props.icon)}
            _materialIcon={isMaterialIcon(props.icon)}
        >
            {props.icon}
        </StIcon>
    );
};
